export const getAttributeOrThrow = (element: Element, selector: string) => {
    const attribute = element.getAttribute(selector);
    if (!attribute) {
        throw new Error(`Attribute "${selector}" is empty.`);
    }

    return attribute;
};
